import { useMutation, useQuery } from "@apollo/client";
import { DELETE_RECEIPT, GET_RECEIPT_DETAIL } from "graphql/receipts";
import { Receipt } from "utils/receipts/receiptFormat";

type ReceiptDetailQueryReturn = {
  receiptDetail: Receipt | null;
};

export type UseReceiptDetailOptions = {
  /**
   * When true, does not run `GET_RECEIPT_DETAIL`. Use when you only need
   * mutations (delete / remove asset) and already have receipt context elsewhere.
   */
  skipQuery?: boolean;
};

export const useReceiptDetail = (
  id: string | undefined,
  options?: UseReceiptDetailOptions,
) => {
  const skipQuery = options?.skipQuery ?? false;
  const { data, loading, error, refetch } = useQuery<ReceiptDetailQueryReturn>(
    GET_RECEIPT_DETAIL,
    {
      variables: { id },
      skip: !id || skipQuery,
    },
  );

  const [deleteReceiptDetail, { loading: deletingReceiptDetail }] =
    useMutation(DELETE_RECEIPT);

  return {
    receiptDetail: data?.receiptDetail ?? null,
    loadingReceiptDetail: loading,
    errorReceiptDetail: error,
    refetchReceiptDetail: refetch,

    deleteReceiptDetail,
    deletingReceiptDetail,
  };
};
